// src/quiz/gre-mock8/index.js
// GRE Mock 8 — props for the shared Gre_verbal / Gre_quantitative /
// Gre_analytical components. Test names end in "Mock 8" so the profile
// keeps these results apart from the other mocks.
import verbalQuestions from "./verbalData";
import { section1Questions, section2Questions } from "./quantitativeData";

export const greMock8 = {
  verbal: {
    questions: verbalQuestions,
    testName: "GRE Verbal Reasoning Mock 8",
    title: "GRE Verbal Reasoning — Mock 8",
  },
  quantitative: {
    section1: section1Questions,
    section2: section2Questions,
    testName: "GRE Quantitative Reasoning Mock 8",
    title: "GRE Quantitative Reasoning — Mock 8",
  },
  analytical: {
    testName: "GRE Analytical Writing Mock 8",
    title: "GRE Analytical — Mock 8",
    prompt:
      "\"The best way for a society to prepare its young people for leadership in government, industry, or other fields is by instilling in them a sense of cooperation, not competition.\"",
    directions:
      "Write a response in which you discuss the extent to which you agree or disagree with the recommendation and explain your reasoning for the position you take. In developing and supporting your position, describe specific circumstances in which adopting the recommendation would or would not be advantageous and explain how these examples shape your position.",
    topicKeywords: [
      "cooperat", "collaborat", "compet", "leader", "young", "societ",
      "teamwork", "government", "industry", "children", "work together",
    ],
  },
};
